import type { CuratedInsightCategory } from '@/types/inbox';

export const CATEGORY_LABEL: Record<CuratedInsightCategory, string> = {
	performance: 'Performance',
	opportunity: 'Opportunity',
	anomaly: 'Anomaly',
	action_needed: 'Action needed',
	experiment_result: 'Experiment',
};

export const CATEGORY_PILL: Record<CuratedInsightCategory, string> = {
	performance: 'bg-blue-50 text-blue-700',
	opportunity: 'bg-emerald-50 text-emerald-700',
	anomaly: 'bg-orange-50 text-orange-700',
	action_needed: 'bg-rose-50 text-rose-700',
	experiment_result: 'bg-fuchsia-50 text-fuchsia-700',
};
